<section class="vc-admin-activity-list">
  <section class="vc-admin-activity-list__filters">
    <div class="vc-admin-activity-list__filters-grid">
      <label class="vc-admin-activity-list__filter">
        <span>{{ "ACTIVITY.FILTERS.SEARCH" | translate }}</span>
        <input
          type="text"
          [(ngModel)]="filters.q"
          [placeholder]="'ACTIVITY.FILTERS.SEARCH_PLACEHOLDER' | translate"
          (keyup.enter)="applyFilters()"
        />
      </label>

      <label class="vc-admin-activity-list__filter">
        <span>{{ "ACTIVITY.FILTERS.ACTION" | translate }}</span>
        <select [(ngModel)]="filters.action">
          <option value="">{{ "COMMON.ALL" | translate }}</option>
          <option *ngFor="let action of meta.actions" [value]="action">
            {{ activityActionLabel(action) }}
          </option>
        </select>
      </label>

      <label class="vc-admin-activity-list__filter">
        <span>{{ "ACTIVITY.FILTERS.USER" | translate }}</span>
        <select [(ngModel)]="filters.users_id">
          <option [ngValue]="null">{{ "COMMON.ALL" | translate }}</option>
          <option *ngFor="let user of meta.users" [ngValue]="user.id">
            {{ user.name || user.email || ("#" + user.id) }}
          </option>
        </select>
      </label>

      <label class="vc-admin-activity-list__filter">
        <span>{{ "ACTIVITY.FILTERS.RESOURCE" | translate }}</span>
        <select [(ngModel)]="filters.resource_type">
          <option value="">{{ "COMMON.ALL" | translate }}</option>
          <option *ngFor="let resourceType of meta.resource_types" [value]="resourceType">
            {{ resourceTypeLabel(resourceType) }}
          </option>
        </select>
      </label>

      <label class="vc-admin-activity-list__filter">
        <span>{{ "ACTIVITY.FILTERS.EVENT_CODE" | translate }}</span>
        <select [(ngModel)]="filters.event_code">
          <option value="">{{ "COMMON.ALL" | translate }}</option>
          <option *ngFor="let eventCode of meta.event_codes" [value]="eventCode">
            {{ eventCodeLabel(eventCode) }}
          </option>
        </select>
      </label>

      <label class="vc-admin-activity-list__filter">
        <span>{{ "ACTIVITY.FILTERS.SITE" | translate }}</span>
        <select [(ngModel)]="filters.site_id">
          <option [ngValue]="null">{{ "COMMON.ALL" | translate }}</option>
          <option *ngFor="let site of meta.sites" [ngValue]="site.id">
            {{ site.name }}
          </option>
        </select>
      </label>

      <label class="vc-admin-activity-list__filter">
        <span>{{ "ACTIVITY.FILTERS.FROM" | translate }}</span>
        <input type="date" [(ngModel)]="filters.from" />
      </label>

      <label class="vc-admin-activity-list__filter">
        <span>{{ "ACTIVITY.FILTERS.TO" | translate }}</span>
        <input type="date" [(ngModel)]="filters.to" />
      </label>
    </div>

    <div class="vc-admin-activity-list__filters-actions">
      <button pButton type="button" class="p-button-sm" (click)="applyFilters()">
        {{ "COMMON.APPLY" | translate }}
      </button>
      <button
        pButton
        type="button"
        class="p-button-sm p-button-outlined p-button-secondary"
        (click)="clearFilters()"
      >
        {{ "COMMON.CLEAR" | translate }}
      </button>
    </div>

    <small class="vc-admin-activity-list__retention">
      {{ "ACTIVITY.RETENTION.ACTIVE" | translate }}: {{ meta.retention.active_total }} ·
      {{ "ACTIVITY.RETENTION.ARCHIVED" | translate }}: {{ meta.retention.archived_total }}
      <ng-container *ngIf="meta.retention.last_archive_at">
        · {{ "ACTIVITY.RETENTION.LAST_ARCHIVE" | translate }}:
        {{ moment(meta.retention.last_archive_at).format("DD/MM/YYYY HH:mm") }}
      </ng-container>
    </small>
  </section>

  <p-table
    [paginator]="true"
    [rows]="rowsPerPage"
    [rowsPerPageOptions]="[20, 40, 100]"
    [value]="events"
    styleClass="Table"
    responsiveLayout="scroll"
    [totalRecords]="totalRecords"
    [lazy]="true"
    (onLazyLoad)="loadLogs($event)"
    [loading]="loading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>{{ "COMMON.DATE" | translate }}</th>
        <th>{{ "ACTIVITY.TABLE.USER" | translate }}</th>
        <th>{{ "COMMON.ACTION" | translate }}</th>
        <th>{{ "COMMON.RESOURCE" | translate }}</th>
        <th>{{ "ACTIVITY.TABLE.SUMMARY" | translate }}</th>
        <th>{{ "ACTIVITY.TABLE.RELATED" | translate }}</th>
        <th>{{ "ACTIVITY.TABLE.CHANGES" | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-event>
      <tr>
        <td>{{ moment(event.created_at).format("DD/MM/YYYY HH:mm:ss") }}</td>
        <td>
          <strong>{{ event.actor.name || "-" }}</strong>
          <div class="vc-admin-activity-list__muted">{{ event.actor.email || "-" }}</div>
        </td>
        <td>{{ activityActionLabel(event.action) }}</td>
        <td>
          <strong>
            {{
              event.primary_resource.label ||
              (resourceTypeLabel(event.primary_resource.type) +
                (event.primary_resource.id ? " #" + event.primary_resource.id : ""))
            }}
          </strong>
          <div class="vc-admin-activity-list__muted" *ngIf="event.primary_resource.id">
            {{ resourceTypeLabel(event.primary_resource.type) }} #{{ event.primary_resource.id }}
          </div>
        </td>
        <td>
          <strong>{{ eventTitle(event) }}</strong>
          <div class="vc-admin-activity-list__muted">
            {{ eventDescription(event) }}
          </div>
        </td>
        <td>
          <div class="vc-admin-activity-list__targets">
            <ng-container *ngFor="let target of resourceTargets(event)">
              <a
                *ngIf="targetRouterLink(target)"
                [routerLink]="targetRouterLink(target)"
                [queryParams]="targetQueryParams(target)"
                class="vc-admin-activity-list__target"
              >
                {{ target.label || (resourceTypeLabel(target.type) + " #" + target.id) }}
              </a>
              <span
                *ngIf="!targetRouterLink(target)"
                class="vc-admin-activity-list__target vc-admin-activity-list__target--disabled"
              >
                {{ target.label || (resourceTypeLabel(target.type) + " #" + target.id) }}
              </span>
            </ng-container>
          </div>
        </td>
        <td>
          <span *ngIf="!getChanges(event).length" class="vc-admin-activity-list__muted">
            {{ "ACTIVITY.TABLE.NO_CHANGES" | translate }}
          </span>
          <ng-container *ngIf="getChanges(event).length">
            {{ getChanges(event).length }}
            {{ "ACTIVITY.TABLE.CHANGES_COUNT" | translate }}
          </ng-container>

          <button
            *ngIf="hasExpandedInfo(event)"
            pButton
            type="button"
            class="p-button-text p-button-sm"
            (click)="toggleExpanded(event.id)"
          >
            {{
              isExpanded(event.id)
                ? ("COMMON.HIDE" | translate)
                : ("COMMON.DETAILS" | translate)
            }}
          </button>
        </td>
      </tr>
      <tr *ngIf="isExpanded(event.id)" class="vc-admin-activity-list__expanded">
        <td colspan="7">
          <div class="vc-admin-activity-list__expanded-grid">
            <div class="vc-admin-activity-list__changes" *ngIf="getChanges(event).length">
              <strong>{{ "ACTIVITY.TABLE.CHANGES" | translate }}</strong>
              <div class="vc-admin-activity-list__changes-list">
                <div class="vc-admin-activity-list__change-chip" *ngFor="let change of getChanges(event)">
                  <span class="vc-admin-activity-list__change-field">
                    {{ fieldLabel(event, change.field) }}
                  </span>
                  <span class="vc-admin-activity-list__change-values">
                    <ng-container *ngIf="hasBeforeValue(change)">
                      <code>{{ formatChangeValue(change.before) }}</code>
                      <span>→</span>
                    </ng-container>
                    <code>{{ formatChangeValue(change.after) }}</code>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
